module.exports = __webpack_public_path__ + "ef2ce4dcf4e30f9c1864b973a99564b6.png";


//////////////////
// WEBPACK FOOTER
// ./application/adminlte/plugins/iCheck/flat/pink.png
// module id = 291
// module chunks = 0